import { MouseEvent, useEffect, useRef, useState } from 'react'
import { Button } from '@mui/material'
import { toast } from 'react-toastify'
import { useSubscribeTeamMutation, useUnsubscribeTeamMutation } from '../../../api/teams'
import { useSettledToggleNetwork } from '../../../hooks/useSettledToggleNetwork'

type TeamSubscribeButtonProps = {
  teamId: number
  isSubscribed?: boolean
  onClick?: (event: MouseEvent<HTMLButtonElement>) => void
  onSubscriptionChange?: (wasSubscribed: boolean) => void
}

export const TeamSubscribeButton = ({
  teamId,
  isSubscribed,
  onClick,
  onSubscriptionChange,
}: TeamSubscribeButtonProps) => {
  const [subscribe, { isLoading: isSubscribing }] = useSubscribeTeamMutation()
  const [unsubscribe, { isLoading: isUnsubscribing }] = useUnsubscribeTeamMutation()
  const isLoading = isSubscribing || isUnsubscribing
  const [isSubscribedLocal, setIsSubscribedLocal] = useState(isSubscribed === true)
  const settle = useSettledToggleNetwork()
  const burstRef = useRef<boolean | null>(null)

  useEffect(() => {
    setIsSubscribedLocal(isSubscribed === true)
  }, [teamId, isSubscribed])

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    onClick?.(event)
    if (event.defaultPrevented) return
    if (isLoading) return

    if (burstRef.current === null) {
      burstRef.current = isSubscribedLocal
    }
    const wasSubscribed = isSubscribedLocal
    const next = !wasSubscribed
    setIsSubscribedLocal(next)
    onSubscriptionChange?.(wasSubscribed)

    settle.schedule({
      desired: next,
      commit: async (desired) => {
        burstRef.current = null
        if (desired) {
          await subscribe({ teamId }).unwrap()
          toast.success('Вы подписались на команду')
        } else {
          await unsubscribe({ teamId }).unwrap()
          toast.success('Вы отписались от команды')
        }
      },
      onSkip: () => {
        burstRef.current = null
      },
      onError: (baseline) => {
        burstRef.current = null
        setIsSubscribedLocal(baseline)
        onSubscriptionChange?.(!baseline)
        toast.error('Не удалось изменить подписку')
      },
    })
  }

  return (
    <Button variant="follow" disabled={isLoading} onClick={handleClick}>
      {isSubscribedLocal ? 'Отписаться' : 'Подписаться'}
    </Button>
  )
}
